export const canEditProfile = (userLogged: number, user: number) => {
  return userLogged === user;
};
